import React, { useEffect, useRef } from 'react';
export function WhatYouGetSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <div ref={sectionRef} id="que-recibes" data-id="element-309">
      {/* WHAT YOU GET */}
      <section className="py-20 px-4" style={{
      background: 'var(--color-cream)'
    }} data-id="element-310">
        <div className="max-w-5xl mx-auto" data-id="element-311">
          <div className="text-center mb-14" data-id="element-312">
            <h2 className="reveal font-playfair text-4xl md:text-5xl font-bold mb-4" style={{
            color: 'var(--color-dark)'
          }} data-id="element-313">
              Qué Recibes
            </h2>
            <p className="reveal reveal-delay-1 font-lato text-lg" style={{
            color: 'rgba(44, 24, 16, 0.6)'
          }} data-id="element-314">
              Todo lo que necesitas para transformar tu piel en 7 días
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center" data-id="element-315">
            {/* PDF Mockup */}
            <div className="reveal flex justify-center" data-id="element-316">
              <div className="relative w-64 md:w-72 rounded-2xl overflow-hidden shadow-2xl" style={{
              background: 'linear-gradient(160deg, #2C1810 0%, #4A2E1E 60%, #3D2015 100%)',
              border: '3px solid rgba(212, 168, 83, 0.4)',
              boxShadow: '0 20px 60px rgba(44, 24, 16, 0.3), 0 0 30px rgba(212, 168, 83, 0.15)',
              minHeight: '340px'
            }} data-id="element-317">
                {/* PDF Cover design */}
                <div className="p-8 flex flex-col justify-between h-full" style={{
                minHeight: '340px'
              }} data-id="element-318">
                  <div data-id="element-319">
                    <div className="w-12 h-1 rounded-full mb-6" style={{
                    background: 'var(--color-gold)'
                  }} data-id="element-320" />
                    <p className="font-lato text-xs uppercase tracking-widest mb-3" style={{
                    color: 'rgba(212, 168, 83, 0.7)'
                  }} data-id="element-321">
                      Protocolo Completo
                    </p>
                    <h3 className="font-playfair text-2xl font-bold leading-tight mb-2" style={{
                    color: 'var(--color-cream)'
                  }} data-id="element-322">
                      Rutina Antiarrugas
                      <br data-id="element-323" />
                      <span style={{
                      color: 'var(--color-gold)'
                    }} data-id="element-324">
                        40+ en 7 Días
                      </span>
                    </h3>
                    <p className="font-playfair text-base italic" style={{
                    color: 'rgba(253, 248, 240, 0.7)'
                  }} data-id="element-325">
                      Exosome Express
                    </p>
                  </div>

                  <div data-id="element-326">
                    <div className="rounded-xl p-4 mb-4" style={{
                    background: 'rgba(212, 168, 83, 0.12)',
                    border: '1px solid rgba(212, 168, 83, 0.2)'
                  }} data-id="element-327">
                      <p className="font-lato text-xs" style={{
                      color: 'rgba(253, 248, 240, 0.8)'
                    }} data-id="element-328">
                        📄38 páginas · PDF completo
                      </p>
                      <p className="font-lato text-xs mt-1" style={{
                      color: 'rgba(253, 248, 240, 0.8)'
                    }} data-id="element-329">
                        ✓ Checklists · ✓ Hojas de trabajo
                      </p>
                    </div>
                    <div className="text-center py-2 rounded-lg font-lato font-black text-sm" style={{
                    background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
                    color: 'var(--color-dark)'
                  }} data-id="element-330">
                      <span className="line-through opacity-60 mr-2" data-id="element-331">€17</span>
                      €6.39 Único
                    </div>
                  </div>
                </div>

                {/* Decorative corner */}
                <div className="absolute top-0 right-0 w-20 h-20 opacity-20" style={{
                background: 'radial-gradient(circle at top right, #D4A853, transparent)'
              }} data-id="element-332" />
              </div>
            </div>

            {/* Bullet list */}
            <div className="space-y-4" data-id="element-333">
              <div className="reveal reveal-delay-1 flex items-start gap-4 rounded-xl p-4" style={{
              background: 'var(--color-light)'
            }} data-id="element-334">
                <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-black" style={{
                background: 'var(--color-gold)',
                color: 'var(--color-dark)'
              }} data-id="element-335">
                  ✓
                </span>
                <div data-id="element-336">
                  <p className="font-lato font-bold text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-337">
                    PDF completo 38 páginas
                  </p>
                  <p className="font-lato text-xs mt-0.5" style={{
                  color: 'rgba(44, 24, 16, 0.65)'
                }} data-id="element-338">
                    Protocolo paso a paso con frameworks y ejemplos reales
                  </p>
                </div>
              </div>

              <div className="reveal reveal-delay-2 flex items-start gap-4 rounded-xl p-4" style={{
              background: 'var(--color-light)'
            }} data-id="element-339">
                <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-black" style={{
                background: 'var(--color-gold)',
                color: 'var(--color-dark)'
              }} data-id="element-340">
                  ✓
                </span>
                <div data-id="element-341">
                  <p className="font-lato font-bold text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-342">
                    Checklist diario imprimible
                  </p>
                  <p className="font-lato text-xs mt-0.5" style={{
                  color: 'rgba(44, 24, 16, 0.65)'
                }} data-id="element-343">
                    AM/PM + aceleradores para no saltarte ningún paso
                  </p>
                </div>
              </div>

              <div className="reveal reveal-delay-3 flex items-start gap-4 rounded-xl p-4" style={{
              background: 'var(--color-light)'
            }} data-id="element-344">
                <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-black" style={{
                background: 'var(--color-gold)',
                color: 'var(--color-dark)'
              }} data-id="element-345">
                  ✓
                </span>
                <div data-id="element-346">
                  <p className="font-lato font-bold text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-347">
                    Hojas de trabajo
                  </p>
                  <p className="font-lato text-xs mt-0.5" style={{
                  color: 'rgba(44, 24, 16, 0.65)'
                }} data-id="element-348">
                    Foto tracker, diagnosis de piel, kit de ingredientes
                  </p>
                </div>
              </div>

              <div className="reveal reveal-delay-4 flex items-start gap-4 rounded-xl p-4" style={{
              background: 'var(--color-light)'
            }} data-id="element-349">
                <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-black" style={{
                background: 'var(--color-gold)',
                color: 'var(--color-dark)'
              }} data-id="element-350">
                  ✓
                </span>
                <div data-id="element-351">
                  <p className="font-lato font-bold text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-352">
                    6 Capítulos detallados
                  </p>
                  <p className="font-lato text-xs mt-0.5" style={{
                  color: 'rgba(44, 24, 16, 0.65)'
                }} data-id="element-353">
                    Diagnóstico, ingredientes, rutinas, aceleradores,
                    mantenimiento
                  </p>
                </div>
              </div>

              <div className="reveal reveal-delay-5 flex items-start gap-4 rounded-xl p-4" style={{
              background: 'var(--color-light)'
            }} data-id="element-354">
                <span className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-black" style={{
                background: 'var(--color-gold)',
                color: 'var(--color-dark)'
              }} data-id="element-355">
                  ✓
                </span>
                <div data-id="element-356">
                  <p className="font-lato font-bold text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-357">
                    FAQ 10+ preguntas reales + glosario 15 términos
                  </p>
                  <p className="font-lato text-xs mt-0.5" style={{
                  color: 'rgba(44, 24, 16, 0.65)'
                }} data-id="element-358">
                    Recursos Mercadona/Amazon incluidos
                  </p>
                </div>
              </div>

              {/* Value stack */}
              <div className="reveal rounded-xl p-4 text-center" style={{
              background: 'var(--color-dark)',
              border: '1px solid rgba(212, 168, 83, 0.3)'
            }} data-id="element-359">
                <p className="font-lato text-sm" style={{
                color: 'rgba(253, 248, 240, 0.7)'
              }} data-id="element-360">
                  Todo esto por solo
                </p>
                <div className="flex items-center justify-center gap-3" data-id="element-361">
                  <p className="font-playfair text-lg line-through opacity-40" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-362">
                    €17
                  </p>
                  <p className="font-playfair text-2xl font-black" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-363">
                    €6.39 único · Acceso lifetime
                  </p>
                </div>
                <p className="font-lato text-xs mt-1" style={{
                color: 'rgba(253, 248, 240, 0.5)'
              }} data-id="element-364">
                  Sin suscripciones. Descarga inmediata.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-20 px-4" style={{
      background: 'var(--color-light)'
    }} data-id="element-365">
        <div className="max-w-4xl mx-auto" data-id="element-366">
          <div className="text-center mb-14" data-id="element-367">
            <h2 className="reveal font-playfair text-4xl md:text-5xl font-bold mb-4" style={{
            color: 'var(--color-dark)'
          }} data-id="element-368">
              Cómo Funciona
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-369">
            <div className="reveal reveal-delay-1 text-center" data-id="element-370">
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mx-auto mb-4 shadow-lg" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 15px rgba(212, 168, 83, 0.35)'
            }} data-id="element-371">
                🛒
              </div>
              <div className="font-lato text-xs font-black uppercase tracking-widest mb-2" style={{
              color: 'var(--color-gold)'
            }} data-id="element-372">
                Paso 1
              </div>
              <p className="font-lato text-sm leading-relaxed" style={{
              color: 'var(--color-dark)'
            }} data-id="element-373">
                Compra 8 ingredientes Mercadona (&lt;12€). Test patch. Foto día
                1.
              </p>
            </div>

            <div className="reveal reveal-delay-2 text-center" data-id="element-374">
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mx-auto mb-4 shadow-lg" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 15px rgba(212, 168, 83, 0.35)'
            }} data-id="element-375">
                ☀️
              </div>
              <div className="font-lato text-xs font-black uppercase tracking-widest mb-2" style={{
              color: 'var(--color-gold)'
            }} data-id="element-376">
                Paso 2
              </div>
              <p className="font-lato text-sm leading-relaxed" style={{
              color: 'var(--color-dark)'
            }} data-id="element-377">
                Rutina AM 5 min + PM 7 min (Exosome Bases + masaje facial)
              </p>
            </div>

            <div className="reveal reveal-delay-3 text-center" data-id="element-378">
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mx-auto mb-4 shadow-lg" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 15px rgba(212, 168, 83, 0.35)'
            }} data-id="element-379">
                💧
              </div>
              <div className="font-lato text-xs font-black uppercase tracking-widest mb-2" style={{
              color: 'var(--color-gold)'
            }} data-id="element-380">
                Paso 3
              </div>
              <p className="font-lato text-sm leading-relaxed" style={{
              color: 'var(--color-dark)'
            }} data-id="element-381">
                Acelera: Hidratación 2L + sueño boca arriba + drenaje linfático
              </p>
            </div>

            <div className="reveal reveal-delay-4 text-center" data-id="element-382">
              <div className="w-16 h-16 rounded-full flex items-center justify-center text-2xl mx-auto mb-4 shadow-lg" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              boxShadow: '0 4px 15px rgba(212, 168, 83, 0.35)'
            }} data-id="element-383">
                📸
              </div>
              <div className="font-lato text-xs font-black uppercase tracking-widest mb-2" style={{
              color: 'var(--color-gold)'
            }} data-id="element-384">
                Paso 4
              </div>
              <p className="font-lato text-sm leading-relaxed" style={{
              color: 'var(--color-dark)'
            }} data-id="element-385">
                Día 7: Foto antes/después. Mantenimiento 1× noche semanas 2-4.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOR WHO / NOT FOR WHO */}
      <section className="py-20 px-4" style={{
      background: 'var(--color-cream)'
    }} data-id="element-386">
        <div className="max-w-4xl mx-auto" data-id="element-387">
          <div className="text-center mb-12" data-id="element-388">
            <h2 className="reveal font-playfair text-4xl md:text-5xl font-bold" style={{
            color: 'var(--color-dark)'
          }} data-id="element-389">
              ¿Es para ti?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-390">
            {/* For */}
            <div className="reveal rounded-2xl p-8" style={{
            background: 'rgba(92, 107, 58, 0.06)',
            border: '2px solid rgba(92, 107, 58, 0.25)'
          }} data-id="element-391">
              <h3 className="font-playfair text-2xl font-bold mb-6 flex items-center gap-3" style={{
              color: 'var(--color-olive)'
            }} data-id="element-392">
                <span className="w-8 h-8 rounded-full flex items-center justify-center text-sm" style={{
                background: 'var(--color-olive)',
                color: 'white'
              }} data-id="element-393">
                  ✓
                </span>
                Para ti si...
              </h3>
              <ul className="space-y-3" data-id="element-394">
                <li className="flex items-start gap-3" data-id="element-395">
                  <span className="text-green-600 font-black mt-0.5 flex-shrink-0" data-id="element-396">
                    ✓
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-397">
                    Mujer 42-55 años en España
                    (Madrid/Barcelona/Valencia/Sevilla)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-398">
                  <span className="text-green-600 font-black mt-0.5 flex-shrink-0" data-id="element-399">
                    ✓
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-400">
                    Oficinista o ama de casa con 5 minutos libres
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-401">
                  <span className="text-green-600 font-black mt-0.5 flex-shrink-0" data-id="element-402">
                    ✓
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-403">
                    Piel mixta 40+ con arrugas de expresión profundas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-404">
                  <span className="text-green-600 font-black mt-0.5 flex-shrink-0" data-id="element-405">
                    ✓
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-406">
                    Compras en Mercadona, scrolleas Meta/TikTok a las 22:00
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-407">
                  <span className="text-green-600 font-black mt-0.5 flex-shrink-0" data-id="element-408">
                    ✓
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-409">
                    Quieres glow real sin cirugías, con presupuesto real
                  </span>
                </li>
              </ul>
            </div>

            {/* Not for */}
            <div className="reveal reveal-delay-2 rounded-2xl p-8" style={{
            background: 'rgba(196, 113, 74, 0.05)',
            border: '2px solid rgba(196, 113, 74, 0.2)'
          }} data-id="element-410">
              <h3 className="font-playfair text-2xl font-bold mb-6 flex items-center gap-3" style={{
              color: 'var(--color-terracotta)'
            }} data-id="element-411">
                <span className="w-8 h-8 rounded-full flex items-center justify-center text-sm" style={{
                background: 'var(--color-terracotta)',
                color: 'white'
              }} data-id="element-412">
                  ✕
                </span>
                No es para ti si...
              </h3>
              <ul className="space-y-3" data-id="element-413">
                <li className="flex items-start gap-3" data-id="element-414">
                  <span className="font-black mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-415">
                    ✕
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-416">
                    Tienes piel sensible extrema sin hacer test patch previo
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-417">
                  <span className="font-black mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-418">
                    ✕
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-419">
                    Buscas milagros en 24 horas
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-420">
                  <span className="font-black mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-421">
                    ✕
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-422">
                    Ya usas retinoides o ácidos (espera 2 semanas)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-423">
                  <span className="font-black mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-424">
                    ✕
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-425">
                    No puedes ser consistente 7 días seguidos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-426">
                  <span className="font-black mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-terracotta)'
                }} data-id="element-427">
                    ✕
                  </span>
                  <span className="font-lato text-sm" style={{
                  color: 'var(--color-dark)'
                }} data-id="element-428">
                    Influencers con tiempo para rutinas de 20 pasos
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>;
}